import React, { FunctionComponent, useEffect } from 'react'
import { connect } from 'react-redux'
import { HubLink } from '../components/hubLink'
import { HubButton } from '../components/hubButton'
import { BadgeGate } from '../features/common/permissions/badgeGate'
import { showAnalyticsModal } from '../actions/modalsActions'
import { fetchAdmin } from '../features/admin/adminActions'
import { selectAdmin } from '../reducers'
import { Callback } from '../utils/types'

export interface LinkProps {
  title: string
  icon: string
  to: string
  requiredBadges?: string[]
  anyBadges?: string[]
  target?: string
  disabledMessage?: string
  type: 'link'
}

export interface ButtonProps {
  title: string
  icon: string
  requiredBadges?: string[]
  anyBadges?: string[]
  actionType: 'analytics'
  type: 'button'
}

type HubItem = LinkProps | ButtonProps

const staticHubItems: HubItem[] = [
  {
    type: 'link',
    title: 'New Applicant',
    icon: 'icon-layers',
    to: '/refiapp',
    requiredBadges: ['REFI_PHONE'],
  },
  // {
  //   type: 'link',
  //   title: 'People',
  //   icon: 'icon-users',
  //   to: 'users?offset=0&limit=25',
  //   requiredBadges: ['USERS'],
  // },
  // {
  //   type: 'link',
  //   title: 'Vehicles',
  //   icon: 'icon-car-side',
  //   to: '/vehicles?offset=0&limit=25&financeable=TRUE&ownershipVerification=VERIFIED',
  //   requiredBadges: ['VEHICLES'],
  // },
  {
    type: 'link',
    title: 'Protection Products',
    icon: 'icon-bank',
    to: 'products?offset=0&limit=25&sort=LAST_DATE&direction=DESC',
    requiredBadges: [],
  },
  // {
  //   type: 'link',
  //   title: 'Refinance',
  //   icon: 'icon-refi',
  //   to: '/refinance',
  //   requiredBadges: ['REFIS'],
  // },
  // {
  //   type: 'link',
  //   title: 'Tasks',
  //   icon: 'icon-clipboard',
  //   to: 'tasks',
  //   requiredBadges: ['TASKS'],
  // }
  {
    type: 'link',
    title: 'Organizations',
    icon: 'icon-bank',
    to: 'organizations',
    requiredBadges: ['SUPERUSER'],
  },
  {
    type: 'button',
    title: 'Analytics',
    icon: 'icon-analytics',
    requiredBadges: ['ANALYTICS'],
    actionType: 'analytics',
  },
  {
    type: 'link',
    title: 'Admins',
    icon: 'icon-users',
    to: 'admins?offset=0&limit=25',
    anyBadges: ['SUPERUSER', 'ADMIN'],
  },
  {
    type: 'link',
    title: 'Configuration',
    icon: 'icon-settings',
    to: 'configuration',
    requiredBadges: ['SUPERUSER'],
  },
  {
    type: 'link',
    title: 'Payments',
    icon: 'icon-refi',
    to: 'https://payments.blinker-prod.com',
    target: '_blank',
    requiredBadges: [],
  }
]

//AS YOU ADD PAGES, MOVE THESE LINKS ONTO HUB LINK LIST

// const futureList = [
//   {
//     title: 'Documents',
//     icon: 'icon-layers',
//     to: '#',
//   },
//   {
//     title: 'Account Management',
//     icon: 'icon-settings',
//     to: '#',
//   }
// ];

const crmHubItem = (ghlLocationId?: string): LinkProps =>
  ghlLocationId
    ? {
        type: 'link',
        title: 'CRM',
        icon: 'icon-group',
        to: `https://crm.blinker.com/v2/location/${ghlLocationId}/dashboard`,
        target: '_blank',
        requiredBadges: [],
      }
    : {
        type: 'link',
        title: 'CRM',
        icon: 'icon-group',
        to: '',
        requiredBadges: [],
        disabledMessage:
          "This organization isn't connected to a GHL location yet.",
      }

export interface Props {
  session: any
  admin: any
  fetchAdmin: Callback
  showAnalyticsModal: Callback
}

export const HubView: FunctionComponent<Props> = ({
  session,
  admin,
  fetchAdmin,
  showAnalyticsModal,
}) => {
  const adminId = session?.user?.id

  // The organization's GHL connection can be set up after login, and admin
  // sessions stay valid for hours without hitting /oauth/login again, so we
  // re-fetch the admin on every Hub visit to pick up ghlLocationId changes.
  useEffect(() => {
    if (adminId) {
      fetchAdmin(adminId)
    }
  }, [adminId])

  const handleButtonClick = (actionType: string) => {
    if (actionType === 'analytics') {
      showAnalyticsModal()
    }
  }

  const ghlLocationId = admin?.organization?.ghlLocationId
  const paymentsIndex = staticHubItems.findIndex(
    (item) => item.title === 'Payments'
  )
  const hubItems = [
    ...staticHubItems.slice(0, paymentsIndex),
    crmHubItem(ghlLocationId),
    ...staticHubItems.slice(paymentsIndex),
  ]

  return (
    <div className="hub">
      <div className="hub-link-grid">
        {hubItems.map((item) => (
          <BadgeGate
            key={item.title}
            disableUI
            requiredBadges={item.requiredBadges}
            anyBadges={item.anyBadges}
          >
            {item.type === 'link' ? (
              <HubLink
                title={item.title}
                icon={item.icon}
                to={item.to}
                target={item.target || undefined}
                disabledMessage={item.disabledMessage}
              />
            ) : (
              <HubButton
                title={item.title}
                icon={item.icon}
                onClick={() => handleButtonClick(item.actionType)}
              />
            )}
          </BadgeGate>
        ))}
      </div>
    </div>
  )
}

export const mapStateToProps = (state) => {
  const { session } = state
  return {
    session,
    admin: selectAdmin(state.adminUsers, session?.user?.id),
  }
}

const mapDispatchToProps = {
  fetchAdmin,
  showAnalyticsModal,
}

export const Hub = connect(mapStateToProps, mapDispatchToProps)(HubView)
